import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=b5285800&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=b5285800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5285800",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b5285800', component.options)
    } else {
      api.reload('b5285800', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=b5285800&scoped=true&", function () {
      api.rerender('b5285800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Styles/Index.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Styles/Index.vue
// module id = Jxbk
// module chunks = 0